import { RouteComponentProps } from 'react-router-dom';
import { IonText, useIonRouter } from '@ionic/react';
import classNames from 'classnames';

import BackButton from 'src/components/BackButton';
import { MOBILE_VIEW } from 'src/constants';
import classes from './MobileHeader.module.scss';
import textClasses from 'src/styles/text.module.scss';

interface MobileHeaderProps extends RouteComponentProps {
  title?: string;
}

const MobileHeader: React.FC<MobileHeaderProps> = ({ history, title }) => {
  const router = useIonRouter();
  const onBackButtonClickMobile = () => {
    // Deeplinks open details via history.replace (PK-213), so there's no back entry to pop.
    // Without this, goBack() is a no-op and the back arrow dead-ends — only add-to-cart or a
    // force-quit escapes. Fall back to the menu when the nav stack has nowhere to go back to.
    if (router.canGoBack()) {
      history.goBack();
    } else {
      router.push('/tabs/menu', 'back');
    }
  };

  return (
    <div className={classNames(classes.header, MOBILE_VIEW)}>
      <BackButton onClick={onBackButtonClickMobile} />
      <IonText className={classNames(textClasses.headerM, classes.headerTitle)}>{title}</IonText>
      <div className={classes.hiddenPlaceholderBackBtn}>
        <BackButton />
      </div>
    </div>
  );
};

export default MobileHeader;
